module.exports = __webpack_public_path__ + "img/rec-05.388dabb6.jpg";